import { format } from 'date-fns'

/**
 * 日付を yyyy/MM/dd 形式にフォーマット
 * @param {string|Date} dateString
 * @returns {string}
 */
export const formatDate = dateString => {
  if (!dateString) return '-'
  try {
    return format(new Date(dateString), 'yyyy/MM/dd')
  } catch (e) {
    return '-'
  }
}

/**
 * 日時を yyyy/MM/dd HH:mm 形式にフォーマット
 * @param {string|Date} dateString
 * @returns {string}
 */
export const formatDateTime = dateString => {
  if (!dateString) return '-'
  try {
    return format(new Date(dateString), 'yyyy/MM/dd HH:mm')
  } catch (e) {
    return '-'
  }
}

/**
 * 金額を ¥X,XXX 形式にフォーマット
 * @param {number} value
 * @returns {string}
 */
export const formatCurrency = value => {
  if (value === null || value === undefined) return '-'

  return `¥${Number(value).toLocaleString()}`
}
